module.exports = __webpack_public_path__ + "static/media/laugh-wink.2d0a6c61.svg";